exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".social-label{color:#999;font-size:14px;display:flex}.custom-social-type{border:1px solid rgba(0,0,0,0);color:#999 !important;padding:0}.custom-social-type:hover{border:1px solid #999}.custom-social-type:focus{padding:0}.social-img-sm-container{padding:0}.social-img-sm{margin-top:4px;width:30px}.social-add-toggle{border:1px solid #000 !important;border-radius:.25rem;color:#ffc000}.social-add-toggle:hover{border:1px solid #ffc000 !important}.social-label-type{margin-top:6px}.social-help-link{cursor:pointer}.social-help-link:hover{color:#ffc000}@media(max-width: 767px){.social-data-row{flex-wrap:wrap}.social-data-row .social-label{flex:0 0 auto;max-width:none;width:auto;order:1}.social-data-row .social-img-sm-container{flex:0 0 auto;max-width:none;width:auto;order:2}.social-data-row .col-7{flex:0 0 100%;max-width:100%;order:3}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/SocialFormPanel/styles.scss
// module id = 651
// module chunks = 0